"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initBrowserMetrics;
var _metricsSender = require("@action/metrics-sender");
function initBrowserMetrics(config, params) {
  if (typeof window !== 'undefined') {
    _metricsSender.Metrics.init({
      env: (config === null || config === void 0 ? void 0 : config.env) || process.env.NEXT_PUBLIC_ENVIRONMENT,
      productName: (config === null || config === void 0 ? void 0 : config.PRODUCT_NAME) || process.env.NEXT_PUBLIC_PRODUCT_NAME || 'onboarding',
      serviceName: (config === null || config === void 0 ? void 0 : config.SERVICE_NAME) || process.env.NEXT_PUBLIC_SERVICE_NAME || 'frontend-teamplate'
    });
    _metricsSender.Metrics.sendBaseMetrics(params);
  }
}